import React from "react";
import AboutUsCard from "../../components/cards/AboutUsCard";

const AboutServiceSection = () => {
  return (
    <div className=" my-24">
      <div className="containers">
        <AboutUsCard />
      </div>
    </div>
  );
};

export default AboutServiceSection;
